const FormPageDone = (props) => {
// const data = props.formData
// console.log('Form page 2 here', props)
  return (

<>
<form className="form"
  style={{
  alignItems: 'center'
}}>

<div className="form-header">Pronto!</div>

<div style={{
  textAlign: 'center'
}}>
  <p>Seus dados foram gravados!</p>
  <p>Se quiser alterar alguma informação, clique em voltar.</p>
</div>


<div className="form-send-row">
<button
  // onClick={() => history.goBack()}
  // disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
  className="login-button"
  onClick={() => props.onPrev()}
>{`${'< Voltar'}`}
</button>
{/* <button
  disabled={true}
  // disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
  className="login-button"
  onClick={() => props.onNext()}
>{`${'Continuar >'}`}</button> */}
</div>
{/* {
!!this.state.error &&
<div className="login-error">{this.state.error}</div>
} */}
</form>
</>
)
}

export default FormPageDone
